import formatByCountry from "./FormatByCountry";

const formatPriceWithoutCurrency = (
  price: number,
  currency: "IDR" | "MYR" = "IDR"
): string => {
  const country = currency === "MYR" ? "MY" : "ID";
  return formatByCountry(price, { type: "money", country });
};
export default formatPriceWithoutCurrency;
